/* =========================================================
   GU RECENTLY VIEWED — Tracking via localStorage
   Se carga en TODAS las páginas (theme.liquid o cart-drawer.liquid)
   Si la página es un producto → guarda info
   Si hay un cart drawer abierto → renderiza recently viewed
   ========================================================= */
(function () {
  'use strict';
  const STORAGE_KEY = 'gu_recently_viewed';
  const MAX_ITEMS = 6;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (_) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (_) {}
  }

  function trackProduct(product) {
    if (!product || !product.handle) return;
    let list = getList();
    // remove if exists
    list = list.filter(p => p.handle !== product.handle);
    // prepend
    list.unshift({
      handle: product.handle,
      url: product.url,
      title: product.title,
      vendor: product.vendor || '',
      image: product.image || '',
      price: product.price || ''
    });
    list = list.slice(0, MAX_ITEMS);
    saveList(list);
  }

  function getRecent(excludeHandle, limit) {
    let list = getList();
    if (excludeHandle) {
      list = list.filter(p => p.handle !== excludeHandle);
    }
    return list.slice(0, limit || 4);
  }

  function renderCard(p) {
    const safeName = (p.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const safeBrand = (p.vendor || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    const safePrice = (p.price || '').replace(/"/g, '&quot;');
    return `
      <a href="${p.url}" class="gu-cart-recent__card">
        <div class="gu-cart-recent__img">
          ${p.image ? `<img src="${p.image}" alt="${safeName}" loading="lazy">` : ''}
        </div>
        <div class="gu-cart-recent__info">
          ${safeBrand ? `<span class="gu-cart-recent__brand">${safeBrand}</span>` : ''}
          <span class="gu-cart-recent__name">${safeName}</span>
          ${safePrice ? `<span class="gu-cart-recent__price">${safePrice}</span>` : ''}
        </div>
      </a>`;
  }

  function renderRecentInDrawer() {
    const container = document.querySelector('.gu-cart-recent');
    if (!container) return;

    // exclude current product (if on product page)
    const currentHandle = document.body.dataset.guProductHandle || null;
    const list = getRecent(currentHandle, 4);

    const listEl = container.querySelector('.gu-cart-recent__list');
    if (!listEl) return;

    if (list.length === 0) {
      container.setAttribute('hidden', '');
      return;
    }

    container.removeAttribute('hidden');
    listEl.innerHTML = list.map(renderCard).join('');
  }

  // Expose globally
  window.GuRecentlyViewed = {
    track: trackProduct,
    getRecent: getRecent,
    render: renderRecentInDrawer
  };

  // Auto-render on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecentInDrawer);
  } else {
    renderRecentInDrawer();
  }

  // Re-render when cart drawer opens (cart-drawer toggle event)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="#cart"]') || e.target.closest('summary a[href*="cart"]') || e.target.closest('[aria-controls="CartDrawer"]')) {
      setTimeout(renderRecentInDrawer, 200);
    }
  });

  // Listen for cart add events
  document.addEventListener('gu:cart:added', function () {
    setTimeout(renderRecentInDrawer, 300);
  });

  // Listen for Dawn cart updates (qty change, remove) — el drawer se re-renderiza y vacía recently viewed
  function bindToDawnUpdates() {
    if (window.PUB_SUB_EVENTS && window.subscribe) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          setTimeout(renderRecentInDrawer, 200);
        });
      } catch (e) {}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindToDawnUpdates);
  } else {
    bindToDawnUpdates();
  }

  // MutationObserver fallback — si el drawer cambia de HTML, re-render
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var observer = new MutationObserver(function (mutations) {
      var hasRecent = drawer.querySelector('.gu-cart-recent__list');
      if (hasRecent && hasRecent.children.length === 0) {
        renderRecentInDrawer();
      }
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
